"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setRequestMetaProperty = exports.getRequestMetaProperty = exports.getRequestMeta = exports.REQUEST_META_SYMBOL_NAME = void 0;
exports.REQUEST_META_SYMBOL_NAME = 'NextRequestMeta';
const META_PROPERTIES = [
    `__NEXT_INIT_QUERY`,
    `__NEXT_INIT_URL`,
    `__nextHadTrailingSlash`,
    `__nextIsLocaleDomain`,
    `__nextStrippedLocale`,
    `_nextDidRewrite`,
    `_nextHadBasePath`,
    `_nextRewroteUrl`,
];
function getRequestMetaSymbol(req) {
    return Object.getOwnPropertySymbols(req).find(symbol => symbol.description === exports.REQUEST_META_SYMBOL_NAME);
}
// Next.js 12+ contains request meta properties in separate object
// that could be accessed only by `NextRequestMeta` symbol
// @see https://github.com/vercel/next.js/blob/v12.1.2/packages/next/server/request-meta.ts
// To be sure properties could be given from request object in next.js 11
// It needs a function that could work with both approaches
function getRequestMeta(req) {
    let symbol = getRequestMetaSymbol(req);
    if (symbol && symbol in req) {
        return req[symbol];
    }
    const metaProps = {};
    META_PROPERTIES.forEach(prop => {
        if (prop in req)
            metaProps[prop] = req[prop];
    });
    symbol = Symbol.for(exports.REQUEST_META_SYMBOL_NAME);
    Object.assign(req, {
        [symbol]: metaProps,
    });
    return metaProps;
}
exports.getRequestMeta = getRequestMeta;
function getRequestMetaProperty(req, prop) {
    return getRequestMeta(req)[prop];
}
exports.getRequestMetaProperty = getRequestMetaProperty;
function setRequestMetaProperty(req, prop, value) {
    const symbol = getRequestMetaSymbol(req) || Symbol.for(exports.REQUEST_META_SYMBOL_NAME);
    const metaProps = req[symbol] || {};
    Object.assign(metaProps, {
        [prop]: value,
    });
    Object.assign(req, {
        [symbol]: metaProps,
    });
}
exports.setRequestMetaProperty = setRequestMetaProperty;
//# sourceMappingURL=getRequestMetaProperty.js.map